import _objectSpread from "C:\\a\\2\\s\\Programs\\Microservices.Common.Frontend\\ecrion-components\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/objectSpread";
import _slicedToArray from "C:\\a\\2\\s\\Programs\\Microservices.Common.Frontend\\ecrion-components\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/slicedToArray"; // @ts-check

import React, { useState, useRef } from 'react';
import { Box } from '@material-ui/core';
import Window from '../../../../modal/Window';
import DataGridView from '../../../../data/Grid/GridView/GridView';
import useLookup from './useLookup';
import useBinding from './useBinding';
import Search from '../controls/Search';
var MODE_CONFIG = {
  hideModeSwitcher: true,
  hideItemsPerPage: true,
  hidePageSelector: false
};

var calculateWidth = function calculateWidth(columnsCount) {
  if (columnsCount > 8) return '90%';
  if (columnsCount > 5) return '75%';
  return '60%';
};
/**
 * @param {import('./types').useBindingHookDataType} bindingData
 * @return {Array<import('./types').useBindingHookDataType>}
 */


var getBindings = function getBindings(bindingData) {
  var bindings = [bindingData];
  bindingData.children.forEach(function (childBindingData) {
    return bindings = bindings.concat(getBindings(childBindingData));
  });
  return bindings;
};

var initialState = function initialState(bindingData) {
  var bindings = getBindings(bindingData);
  return {
    selectedItems: bindings.map(function () {
      return [];
    }),
    // an array of arrays of indexes selected in the dialog
    bindings: bindings,
    bindingIdx: 0
  };
};
/**
 * A lookup dialog shown when we want to perform a lookup for an element
 * @param {import('./types').LookupDialogProperties} param
 * @returns
 */


var LookupDialog = function LookupDialog(_ref) {
  var onClose = _ref.onClose,
      fieldId = _ref.fieldId,
      title = _ref.title;
  title = title || 'Lookup';
  var binding = useBinding(fieldId);

  var _ref2 = binding || {},
      apply = _ref2.apply,
      bindingData = _ref2.data;

  var timeoutRef = useRef(null);

  var _useState = useState(initialState(bindingData)),
      _useState2 = _slicedToArray(_useState, 2),
      state = _useState2[0],
      setState = _useState2[1];

  var selectedData = useRef(state.bindings.map(function () {
    return {};
  }));
  var lookup = useLookup(state.bindings[state.bindingIdx]);
  var allowMultiLookupSelection = bindingData && bindingData.allowMultiLookupSelection;
  var finalState = state.bindingIdx === state.bindings.length - 1;
  var firstState = state.bindingIdx === 0;
  var visibleColumns = lookup.columns.filter(function (c) {
    return !c.hideInLookupDialog;
  });
  var columns = visibleColumns.map(function (c) {
    return {
      id: c.id,
      children: c.name,
      label: c.name,
      formatter: function formatter(_ref3) {
        var data = _ref3.data;
        return data && data[c.id] || '-';
      },
      filterable: true,
      sortable: true,
      style: {
        minWidth: 200
      }
    };
  });
  var sortedRows = !lookup.view.by ? lookup.rows : lookup.rows.sort(function (leftRow, rightRow) {
    var leftColumnValue = leftRow.values.find(function (v) {
      return v.id === lookup.view.by;
    });
    var rightColumnValue = rightRow.values.find(function (v) {
      return v.id === lookup.view.by;
    });
    var leftValue = leftColumnValue.value || '';
    var rightValue = rightColumnValue.value || '';
    var leftValueNumber = Number(leftValue);
    var rightValueNumber = Number(rightValue);
    if (!Number.isNaN(leftValueNumber) && !Number.isNaN(rightValueNumber)) return lookup.view.sort === 'asc' ? leftValueNumber - rightValueNumber : rightValueNumber - leftValueNumber;
    return lookup.view.sort === 'asc' ? leftValue.localeCompare(rightValue) : rightValue.localeCompare(leftValue);
  });
  var data = sortedRows.map(function (r) {
    var row = {
      Id: r.id,
      Selected: state.selectedItems[state.bindingIdx].includes(r.id),
      Context: r.context
    };
    r.values.forEach(function (v, idx) {
      row[lookup.columns[idx].id] = v.value;
    });
    return row;
  });
  /**
   * @param {import('react').SyntheticEvent} e
   * @param {any} value
   * @param {string} columnId
   * @returns {any}
   */

  var onChangeFilter = function onChangeFilter(e, value, columnId) {
    if (timeoutRef.current) clearTimeout(timeoutRef.current);
    timeoutRef.current = setTimeout(function () {
      lookup.actions.filter(columnId, value);
    }, 500);
  };
  /** @param {string} value */


  var onSearch = function onSearch(value) {
    lookup.actions.filter('', value);
  };

  var onChangePage = function onChangePage(e, page) {
    lookup.actions.changePage(page);
  };
  /**
   * @param {import('react').SyntheticEvent} e
   * @param {any} columnId
   * @return {any}
   */


  var onChangeSort = function onChangeSort(e, columnId) {
    lookup.actions.sort(columnId);
  };

  var onItemClicked = function onItemClicked(e, item) {
    var selectedItems = state.selectedItems; // reset selected items if multiple selection not allowed

    if (!allowMultiLookupSelection) {
      selectedItems[state.bindingIdx] = [];
      selectedData.current[state.bindingIdx] = {};
    }

    if (selectedItems[state.bindingIdx].includes(item.Id)) {
      selectedItems[state.bindingIdx].splice(selectedItems[state.bindingIdx].indexOf(item.Id), 1); // delete data for specified item

      delete selectedData.current[state.bindingIdx][item.Id];
    } else {
      selectedItems[state.bindingIdx].push(item.Id);
      var _data = {
        values: lookup.columns.map(function (c) {
          return item[c.id];
        }),
        context: item.Context
      };
      selectedData.current[state.bindingIdx][item.Id] = _data;
    }

    setState(function (prevState) {
      return _objectSpread({}, prevState, {
        selectedItems: selectedItems
      });
    });
  };

  var applyBinding = function applyBinding(data) {
    apply(data);
  };

  var onItemDoubleClicked = function onItemDoubleClicked(e, item) {
    if (allowMultiLookupSelection) return;
    var data = [{}];
    data[0][item.Id] = {
      values: lookup.columns.map(function (c) {
        return item[c.id];
      }),
      context: item.Context
    }; // if we reached this, then we have single selection, so we'll use the single row

    applyBinding(data);
    onClose();
  };

  var onSubmit = function onSubmit() {
    if (finalState) {
      applyBinding(selectedData.current);
      onClose();
    } else {
      setState(function (prevState) {
        return _objectSpread({}, prevState, {
          bindingIdx: prevState.bindingIdx + 1
        });
      });
    }
  };

  var onCancel = function onCancel() {
    if (firstState) onClose();else {
      setState(function (prevState) {
        return _objectSpread({}, prevState, {
          bindingIdx: prevState.bindingIdx - 1
        });
      });
    }
  };

  var isLoading = lookup.loading;
  var error = lookup.error ? {
    error: lookup.error
  } : null;
  title = lookup.searchLabel ? title + " ".concat(lookup.searchLabel) : title;
  var view = lookup.view;
  var paginatedData = data.slice(view.page * view.itemsPerPage, (view.page + 1) * view.itemsPerPage - 1);
  return React.createElement(Window, {
    onClose: onClose,
    style: {
      width: calculateWidth(columns.length)
    },
    header: title,
    disableRestoreFocus: true,
    preventWindowClosing: true,
    renderContent: function renderContent() {
      return React.createElement(React.Fragment, null, React.createElement(DataGridView, Object.assign({}, MODE_CONFIG, {
        onChangeFilter: onChangeFilter,
        onChangeSort: onChangeSort,
        onChangePage: onChangePage,
        onClick: onItemClicked,
        onDoubleClick: onItemDoubleClicked,
        paginationStyle: {
          position: 'fixed',
          bottom: 0,
          width: 'calc(100% - 200px)'
        },
        styles: {
          tableLayoutAuto: true,
          elevation: 0
        },
        config: {
          idKeyProp: 'Id',
          selectedKeyProp: 'Selected',
          columns: columns,
          data: paginatedData,
          count: data.length,
          view: _objectSpread({
            isLoading: isLoading,
            error: error
          }, view)
        }
      })));
    },
    footerButtons: {
      submit: {
        onClick: onSubmit,
        disabled: (!state.selectedItems[state.bindingIdx] || !state.selectedItems[state.bindingIdx].length) && state.bindingIdx == 0,
        children: state.bindingIdx < state.bindings.length - 1 ? 'Next' : 'Save',
        pendingChildren: 'Saving'
      },
      cancel: {
        onClick: onCancel,
        children: state.bindingIdx > 0 ? 'Back' : 'Cancel'
      }
    }
  });
};

export default LookupDialog;